import React from 'react'
import { Popup } from '@mobiscroll/react-latest'

interface IModalProps {
  children: React.ReactNode
  isOpen: boolean
  maxHeight?: number | string
  width?: number | string
  onClose?: () => void
}

const Modal = ({
  children,
  isOpen,
  maxHeight = 'fit-content',
  width = 400,
  // tslint:disable-next-line
  onClose = () => {}
}: IModalProps) => {
  return (
    <Popup cssClass='rp-popup' isOpen={isOpen} maxHeight={maxHeight} width={width} onClose={onClose}>
      {children}
    </Popup>
  )
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/common/Modal.tsx